/* eslint-disable */
import { prodEnvironment } from "@/env/env";
import { loadTicket, ticketExistant } from "./tickets.service";
import { ref, watch } from "vue";
import { toastController, loadingController } from "@ionic/vue";
import {
  cloudDoneOutline,
  personAddOutline,
  navigateCircleOutline,
  imageOutline,
  personRemoveOutline,
  informationOutline,
  createOutline,
  trashBinOutline,
} from "ionicons/icons";
import {
  gestionCadastre,
  gestionCouches,
  gestionFonds,
  infoDevice,
  isOpenAppui,
  isOpenChambre,
  isOpenImmeuble,
} from "./map.services";

import { Toast } from "@capacitor/toast";
import { Haptics, NotificationType } from "@capacitor/haptics";
import { Geolocation } from "@capacitor/geolocation";
import { Preferences } from '@capacitor/preferences';
import { resetSessionTimer } from "./session.services";


export const nbUsers = ref(0);
export const nbTickets = ref(0);
export const nbAnnotations = ref(0);

export const isOpenEditUser = ref(false);
export const isOpenAlert = ref(false);
export const isOpenAlert2 = ref(false);

export const showAppuis = ref(true);
export const showLogements = ref(true);
export const showCadastre = ref(false);
export const showAnnotations = ref(true);
export const showSatellite = ref(false);
export const showCD2 = ref(false);
export const showBD2 = ref(false);


watch(showLogements, (nouvelEtat, ancienEtat) => {
  gestionCouches("arcep", nouvelEtat);
});

watch(showAppuis, (nouvelEtat, ancienEtat) => {
  gestionCouches("appuis", nouvelEtat);
});

watch(showCadastre, (nouvelEtat, ancienEtat) => {
  gestionCadastre("batiment", nouvelEtat);
  gestionCadastre("parcelle", nouvelEtat);
});

watch(showSatellite, (nouvelEtat, ancienEtat) => {
  gestionFonds("satellite", nouvelEtat);
});

watch(showBD2, (nouvelEtat, ancienEtat) => {
  gestionCouches("etude_noeud", nouvelEtat);
});

watch(showCD2, (nouvelEtat, ancienEtat) => {
  gestionCouches("etude_cable", nouvelEtat);
});



watch(showAnnotations, (nouvelEtat, ancienEtat) => {
  gestionCouches("annotations", nouvelEtat);
});

export const showLoading = async (text: string, milliseconds: any) => {
  const loading = await loadingController.create({
    message: text,
    duration: milliseconds,
  });

  loading.present();
};

export const tokenIsDead = async () => {
  isOpenEditUser.value = false;
  isOpenChambre.value = false;
  isOpenAppui.value = false;
  isOpenImmeuble.value = false;
  isOpenAlert.value = true;
  await resetSessionTimer();
};

export const presentToast = async (texte: any, image: any) => {
  if (infoDevice.platform == "web") {
    switch (image) {
      case "cloud-done-outline":
        image = cloudDoneOutline;
        break;
      case "person-add-outline":
        image = personAddOutline;
        break;
      case "navigate-circle-outline":
        image = navigateCircleOutline;
        break;
      case "images-outline":
        image = imageOutline;
        break;
      case "person-remove-outline":
        image = personRemoveOutline;
        break;
      case "create-outline":
        image = createOutline;
        break;
      case "trash-bin-outline":
        image = trashBinOutline;
        break;
      default:
        image = informationOutline;
        break;
    }
    const toast = await toastController.create({
      message: texte,
      duration: 1500,
      position: "top",
      icon: image,
    });

    await toast.present();
  } else {
    Haptics.notification({
      type: NotificationType.Success,
    });
    await Toast.show({
      text: texte,
      duration: "short",
      position: "bottom",
    });
  }
};

export const changeUserStateService = async (mail: string, state: boolean) => {
  const response = await fetch(
    `${prodEnvironment.baseUrl}api/updateSubscribe`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: mail, state: state }),
    }
  );
  const data = response;
  return await data;
};

export const getUsersServive = async () => {
  const response = await fetch(`${prodEnvironment.baseUrl}api/users`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = response;
  return await data;
};

export const getUsersTableService = async () => {
  const response = await fetch(`${prodEnvironment.baseUrl}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = response;
  return await data;
};

export const getUsersLastProjectsService = async () => {
  const response = await fetch(`${prodEnvironment.baseUrl}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = response;
  return await data;
};

export const getUsersLastUsersService = async () => {
  const response = await fetch(`${prodEnvironment.baseUrl}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = response;
  return await data;
};

export const getUsersLastTicketsService = async () => {
  const response = await fetch(`${prodEnvironment.baseUrl}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = response;
  return await data;
};

export const getCompanyUsers = async () => {
  const response = await fetch(
    `${prodEnvironment.baseUrl}api/getcompanyusers`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.json();
  // Normalise en tableau
  const arr = Array.isArray(data) ? data : data ? [data] : [];
  const tableauSansDoublons = arr.filter(
    (objet: any, index: any, self: any) =>
      index === self.findIndex((o: any) => o.email === objet.email)
  );
  return tableauSansDoublons;
};
//export const filteredListUsers = async () => {
export const filteredListUsers = async () => {
  return await getCompanyUsers();
};

export const getCompanyIntervenants = async (idTicket: any) => {
  //console.log(`${prodEnvironment.baseUrl}api/ticket/${idTicket}/intervenants`)
  const response = await fetch(
    `${prodEnvironment.baseUrl}api/v2/intervenants/${idTicket}`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.text();
  //console.log(data);
  return data;
};

export const filteredListIntervenants = async (idTicket: any) => {
  return await getCompanyIntervenants(idTicket);
};

export const addIntervenants = async (idTicket: any, id_intervenant: any) => {
  //console.log(`${prodEnvironment.baseUrl}api/v2/ticketintervenant/${idTicket}/${id_intervenant}`)
  const response = await fetch(
    `${prodEnvironment.baseUrl}api/v2/ticketintervenant/${idTicket}/${id_intervenant}`,
    {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.text();
  presentToast("Intervenant ajouté", "person-add-outline");
  loadTicket(
    ticketExistant.value.siren,
    ticketExistant.value.id_immeuble,
    idTicket
  );
  return data;
};

export const removeIntervenants = async (
  idTicket: any,
  id_intervenant: any
) => {
  const response = await fetch(
    `${prodEnvironment.baseUrl}api/v2/ticketintervenant/${idTicket}/${id_intervenant}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.text();
  presentToast("Intervenant retiré", "person-remove-outline");
  loadTicket(
    ticketExistant.value.siren,
    ticketExistant.value.id_immeuble,
    idTicket
  );
  return data;
};

export const editManagedUser = async (managedEmail: string) => {
  const response = await fetch(
    `${prodEnvironment.baseUrl}api/managed-user/${managedEmail}`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const sendSupportMessageService = async (messageContent: {
  deviceInfo: {
    model: string;
    os: string;
    osVersion: string;
  };
  message: string;
}) => {
  //console.log(messageContent)
  const response = await fetch(
    `${prodEnvironment.baseUrl}api/send-message-support`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(messageContent),
    }
  );
  const data = response;
  return await data;
};

export const exportUserService = async () => {
  const response = await fetch(
    `${prodEnvironment.baseUrl}api/users/export/excel`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  const data = response;
  return await data;
};

export const checkLocationUserService = async () => {
  let statusLocation:any;
  statusLocation = await Geolocation.checkPermissions();
  return statusLocation; 
};

export const requestLocationUserService = async () => {
  let statusLocation:any;
  statusLocation = await Geolocation.requestPermissions();
  return statusLocation; 
}


export const setLocation = async (state: string) => {
  await Preferences.set({ key: 'location', value: state });
  //console.log(` location is set to ${state}`)
}
